import React from "react";
import ReactHtmlParser from "react-html-parser";

function Text({ content }) {
  if (!content) {
    return "";
  }
  return (
    <div className="rounded-lg shadow-lg p-5 overflow-auto max-h-screen">
      <div>{ReactHtmlParser(content)}</div>
    </div>
  );
}

export default Text;
